import { Drawer } from '@mui/material';
import React, { useState } from 'react';
import styles from '../styles/SettingsDrawer.module.scss';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';

export default function SettingsDrawer({ open, toggleDrawer,theme, setSnackType, handleClick, setSnackMessage}) {
    const { t } = useTranslation()
    const [password,setPassword] = useState('')

   
    const Save = async () => {
        if (!password?.trim()) {
            setSnackType('error')
            handleClick()
            setSnackMessage(t('PasswordError'))
            return
        }
        try {
            const id = secureLocalStorage.getItem('user')?.Id
            const { data } = await axios.post(process.env.REACT_APP_test_url + `/api/users/${id}/password`, {
                password: password?.trim()
            }, {
                headers: {
                    'Authorization': `Bearer ${secureLocalStorage.getItem('token')}`
                }
            })
            if (data) {
                setSnackType('success')
                handleClick()
                setSnackMessage(t('PasswordChanged'))
                setPassword('')
                toggleDrawer(false)()
            }
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <Drawer open={open} anchor={window.innerWidth < 600 ?"bottom":'right'} onClose={toggleDrawer(false)}
            PaperProps={{
                className: styles.paper,
            }}>
            <div className={styles.account_drawer}>
                <div className={styles.close_icon} onClick={toggleDrawer(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
                        <path d="M12 4.00003L4 12M3.99997 4L11.9999 12" stroke="#51525C" strokeLinecap="round" />
                    </svg>
                </div>
                <div className={styles.top_drawer}>
                    <div className={styles.drawer_header}>
                        <span className={styles.icon}>

                        <svg xmlns="http://www.w3.org/2000/svg" width={'1.6vh'} height={'1.6vh'}  viewBox="0 0 16 16" fill="none">
                            <path fill='#fcfcfc' fill-rule="evenodd" clip-rule="evenodd" d="M9.51921 1.43353C9.27231 1.33203 8.95932 1.33203 8.33333 1.33203C7.70735 1.33203 7.39435 1.33203 7.14746 1.43353C6.81827 1.56885 6.55673 1.82842 6.42037 2.15512C6.35813 2.30426 6.33377 2.4777 6.32423 2.73069C6.31023 3.10248 6.1181 3.44663 5.79344 3.63265C5.46879 3.81867 5.07243 3.81172 4.74099 3.63787C4.51545 3.51956 4.35192 3.45378 4.19066 3.43271C3.83739 3.38655 3.48012 3.48156 3.19744 3.69683C2.98542 3.85828 2.82893 4.1273 2.51594 4.66532C2.20294 5.20334 2.04645 5.47235 2.01156 5.7353C1.96506 6.0859 2.06079 6.44047 2.2777 6.72102C2.3767 6.84907 2.51585 6.95672 2.7318 7.09138C3.04928 7.28935 3.25355 7.6266 3.25353 7.99871C3.25351 8.37078 3.04924 8.70798 2.7318 8.90593C2.51581 9.04061 2.37665 9.14827 2.27763 9.27633C2.06072 9.55688 1.96499 9.91145 2.0115 10.262C2.04638 10.525 2.20288 10.794 2.51587 11.332C2.82886 11.8701 2.98536 12.1391 3.19737 12.3005C3.48005 12.5158 3.83733 12.6108 4.19059 12.5646C4.35185 12.5436 4.51537 12.4778 4.74089 12.3595C5.07235 12.1856 5.46873 12.1787 5.79341 12.3647C6.11809 12.5508 6.31022 12.8949 6.32424 13.2667C6.33377 13.5197 6.35813 13.6931 6.42037 13.8423C6.55673 14.169 6.81827 14.4285 7.14746 14.5639C7.39435 14.6654 7.70735 14.6654 8.33333 14.6654C8.95932 14.6654 9.27231 14.6654 9.51921 14.5639C9.8484 14.4285 10.1099 14.169 10.2463 13.8423C10.3085 13.6931 10.3329 13.5197 10.3424 13.2667C10.3564 12.8949 10.5485 12.5508 10.8732 12.3647C11.1979 12.1787 11.5943 12.1856 11.9257 12.3595C12.1512 12.4778 12.3148 12.5435 12.476 12.5646C12.8293 12.6108 13.1865 12.5157 13.4692 12.3005C13.6812 12.139 13.8377 11.87 14.1507 11.332C14.4637 10.794 14.6202 10.525 14.6551 10.262C14.7016 9.91141 14.6059 9.55684 14.389 9.27629C14.29 9.14823 14.1508 9.04058 13.9348 8.9059C13.6174 8.70794 13.4131 8.37072 13.4131 7.99864C13.4132 7.6266 13.6174 7.28942 13.9348 7.09149C14.1508 6.9568 14.29 6.84914 14.389 6.72106C14.6059 6.44052 14.7017 6.08594 14.6552 5.73535C14.6203 5.4724 14.4638 5.20339 14.1508 4.66536C13.8378 4.12734 13.6813 3.85833 13.4693 3.69688C13.1866 3.48161 12.8293 3.3866 12.4761 3.43275C12.3148 3.45382 12.1513 3.5196 11.9258 3.6379C11.5943 3.81176 11.1979 3.81871 10.8733 3.63267C10.5486 3.44664 10.3564 3.10247 10.3424 2.73066C10.3329 2.47768 10.3085 2.30425 10.2463 2.15512C10.1099 1.82842 9.8484 1.56885 9.51921 1.43353ZM8.33333 9.9987C9.44631 9.9987 10.3486 9.10327 10.3486 7.9987C10.3486 6.89413 9.44631 5.9987 8.33333 5.9987C7.22035 5.9987 6.3181 6.89413 6.3181 7.9987C6.3181 9.10327 7.22035 9.9987 8.33333 9.9987Z"/>
                        </svg>
                        </span>
                        {t('Settings')}
                    </div>
                    <div className={styles.drawer_body}>
                        <div className={styles.label_input}>
                            <label htmlFor="name">{t('Email')}</label>
                            <input type="text" id='name' placeholder={t('Email')} readOnly value={secureLocalStorage.getItem('user')?.Email}/>
                        </div>
                        <div className={styles.label_input}>
                            <label htmlFor="name">{t('FirstName')}</label>
                            <input type="text" id='name' placeholder={t('FirstName')} readOnly value={secureLocalStorage.getItem('user')?.FirstName}/>
                        </div>
                        <div className={styles.label_input}>
                            <label htmlFor="name">{t('LastName')}</label>
                            <input type="text" id='name' placeholder={t('LastName')} readOnly value={secureLocalStorage.getItem('user')?.LastName}/>
                        </div>
                        <div className={styles.label_input}>
                            <label htmlFor="name">{t('NewPassword')}</label>
                            <input type="text" id='name' placeholder={t('NewPassword')} onChange={(e)=>setPassword(e.target.value)}/>
                        </div>
                    </div>
                </div>
                <div className={styles.drawer_footer}>
                    <div onClick={toggleDrawer(false)}>{t('Cancel')}</div>
                    <button onClick={()=>{Save()}}>{t('Save')}</button>
                </div>
            </div>
        </Drawer>
    )
}
